import {Icon} from "types/Icon";
import {InformationCircleIcon} from "@heroicons/react/outline";

type BubbleProps = {
  label?: string;
  text: string;
  icon: Icon
};

function Bubble({label, text, icon: Icon = InformationCircleIcon}: BubbleProps) {
  return (
    <div className="flex items-start gap-3 rounded-2xl bg-grey-100 p-4 shadow-sm">
      <Icon className="h-6 w-6 flex-shrink-0 text-grey-500" aria-hidden="true" />

      <div className="flex flex-col gap-2 text-sm">
        <p className="font-semibold text-grey-500">{label}</p>
        <p className="leading-normal text-grey-700">{text}</p>
      </div>
    </div>
  );
}

export {Bubble};